import 'react';
import { makeKeyListener } from '@i-ark/utils';
import { transparentCls, transparentLabelCls } from './Transparent.style.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { TransparentIcon } from '../../icons/TransparentIcon.js';

const Transparent = ({
  selected,
  onPreview,
  onPreviewReset,
  onClick
}) => {
  const handlePreview = () => {
    if (onPreview !== undefined) {
      onPreview("transparent");
    }
  };
  const handlePreviewReset = () => {
    if (onPreviewReset !== undefined) {
      onPreviewReset();
    }
  };
  const handleClick = evt => {
    if (onClick !== undefined) {
      onClick("transparent");
    }
    evt.stopPropagation();
  };
  const handleKeyDown = makeKeyListener(["Enter", " "], evt => {
    handleClick(evt);
    evt.stopPropagation();
    evt.preventDefault();
  });
  return /*#__PURE__*/jsxs("li", {
    role: "option",
    "aria-selected": selected,
    tabIndex: 0,
    className: transparentCls,
    "data-transparent": true,
    onMouseEnter: handlePreview,
    onMouseLeave: handlePreviewReset,
    onFocus: handlePreview,
    onBlur: handlePreviewReset,
    onClick: handleClick,
    onKeyDown: handleKeyDown,
    children: [/*#__PURE__*/jsx(TransparentIcon, {
      size: 14,
      color: "#666"
    }), /*#__PURE__*/jsx("span", {
      className: transparentLabelCls,
      children: "Transparent"
    })]
  });
};

export { Transparent };
//# sourceMappingURL=Transparent.js.map
